/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menu_SheetInputs */

const th_menu_sheet = /** @type {(inputs: Menu_SheetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การนำทางและการตั้งค่า`)
};

const en_menu_sheet = /** @type {(inputs: Menu_SheetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigation and settings`)
};

const ja_menu_sheet = /** @type {(inputs: Menu_SheetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ナビゲーションと設定`)
};

const zh_menu_sheet = /** @type {(inputs: Menu_SheetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导航与设置`)
};

const es_menu_sheet = /** @type {(inputs: Menu_SheetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegación y ajustes`)
};

const pt_menu_sheet = /** @type {(inputs: Menu_SheetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegação e configurações`)
};

const id_menu_sheet = /** @type {(inputs: Menu_SheetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigasi dan pengaturan`)
};

const fr_menu_sheet = /** @type {(inputs: Menu_SheetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigation et réglages`)
};

const tl_menu_sheet = /** @type {(inputs: Menu_SheetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nabigasyon at mga setting`)
};

const vi_menu_sheet = /** @type {(inputs: Menu_SheetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Điều hướng và thiết lập`)
};

const ko_menu_sheet = /** @type {(inputs: Menu_SheetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`탐색 및 설정`)
};

const de_menu_sheet = /** @type {(inputs: Menu_SheetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigation und Einstellungen`)
};

const ru_menu_sheet = /** @type {(inputs: Menu_SheetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Навигация и настройки`)
};

const tr_menu_sheet = /** @type {(inputs: Menu_SheetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gezinme ve ayarlar`)
};

const it_menu_sheet = /** @type {(inputs: Menu_SheetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigazione e impostazioni`)
};

const pl_menu_sheet = /** @type {(inputs: Menu_SheetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nawigacja i ustawienia`)
};

const uk_menu_sheet = /** @type {(inputs: Menu_SheetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Навігація та налаштування`)
};

const hi_menu_sheet = /** @type {(inputs: Menu_SheetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नेविगेशन और सेटिंग्स`)
};

const ar_menu_sheet = /** @type {(inputs: Menu_SheetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التنقل والإعدادات`)
};

const ms_menu_sheet = /** @type {(inputs: Menu_SheetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigasi dan tetapan`)
};

const bn_menu_sheet = /** @type {(inputs: Menu_SheetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`চলাচল ও সেটিংস`)
};

const zh_tw2_menu_sheet = /** @type {(inputs: Menu_SheetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`導覽與設定`)
};

const zh_hk2_menu_sheet = /** @type {(inputs: Menu_SheetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`導覽與設定`)
};

const ur_menu_sheet = /** @type {(inputs: Menu_SheetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نیویگیشن اور ترتیبات`)
};

const fa_menu_sheet = /** @type {(inputs: Menu_SheetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پیمایش و تنظیمات`)
};

const sw_menu_sheet = /** @type {(inputs: Menu_SheetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Urambazaji na mipangilio`)
};

const nl_menu_sheet = /** @type {(inputs: Menu_SheetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigatie en instellingen`)
};

/**
* | output |
* | --- |
* | "Navigation and settings" |
*
* @param {Menu_SheetInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const menu_sheet = /** @type {((inputs?: Menu_SheetInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menu_SheetInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_menu_sheet(inputs)
	if (locale === "ja") return ja_menu_sheet(inputs)
	if (locale === "zh") return zh_menu_sheet(inputs)
	if (locale === "es") return es_menu_sheet(inputs)
	if (locale === "pt") return pt_menu_sheet(inputs)
	if (locale === "id") return id_menu_sheet(inputs)
	if (locale === "fr") return fr_menu_sheet(inputs)
	if (locale === "tl") return tl_menu_sheet(inputs)
	if (locale === "vi") return vi_menu_sheet(inputs)
	if (locale === "ko") return ko_menu_sheet(inputs)
	if (locale === "de") return de_menu_sheet(inputs)
	if (locale === "ru") return ru_menu_sheet(inputs)
	if (locale === "tr") return tr_menu_sheet(inputs)
	if (locale === "it") return it_menu_sheet(inputs)
	if (locale === "pl") return pl_menu_sheet(inputs)
	if (locale === "uk") return uk_menu_sheet(inputs)
	if (locale === "hi") return hi_menu_sheet(inputs)
	if (locale === "ar") return ar_menu_sheet(inputs)
	if (locale === "ms") return ms_menu_sheet(inputs)
	if (locale === "bn") return bn_menu_sheet(inputs)
	if (locale === "zh-TW") return zh_tw2_menu_sheet(inputs)
	if (locale === "zh-HK") return zh_hk2_menu_sheet(inputs)
	if (locale === "ur") return ur_menu_sheet(inputs)
	if (locale === "fa") return fa_menu_sheet(inputs)
	if (locale === "sw") return sw_menu_sheet(inputs)
	if (locale === "nl") return nl_menu_sheet(inputs)
	return en_menu_sheet(inputs)
});